// src/pages/AttemptGrading.jsx
import React, {useEffect, useMemo, useRef, useState} from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

const card = { border:'1px solid #e5e7eb', borderRadius:12, background:'#fff', padding:14 };
const row  = { display:'grid', gridTemplateColumns:'1fr 280px', gap:12, alignItems:'start' };
const label = { color:'#6b7280', fontSize:13 };

function clampToMax(v, max) {
    if (v == null || v === '') return '';
    let x = (typeof v === 'string') ? v.replace(',', '.') : v;
    let num = Number(x);
    if (!Number.isFinite(num)) return '';
    if (num < 0) num = 0;
    if (Number.isFinite(max)) num = Math.min(num, Number(max));
    // normujemy do max 2 miejsca po przecinku
    return Math.round(num * 100) / 100;
}



function FileTile({ f }) {
    const mime = String(f.mimetype || '').toLowerCase();
    const isImg = mime.startsWith('image/');
    const isPdf = mime === 'application/pdf' || mime.startsWith('application/pdf');

    return (
        <div style={{ border:'1px solid #eee', borderRadius:8, padding:10 }}>
            {isImg && f.url ? (
                <img
                    src={f.url}
                    alt={f.filename}
                    style={{ width:'100%', maxHeight:260, objectFit:'contain', borderRadius:6 }}
                />
            ) : (
                <div style={{ fontWeight:600 }}>{f.filename}</div>
            )}
            {f.url && (
                <div style={{ marginTop:8 }}>
                    <a href={f.url} target="_blank" rel="noreferrer">
                        {isPdf ? 'Otwórz PDF w nowej karcie' : 'Pobierz / Otwórz w nowej karcie'}
                    </a>
                </div>
            )}
        </div>
    );
}


function AnswerView({ item }) {
    const t = item.type;

    // Opcje (single/multi/etc.)
    if (['single','multi','dropdown'].includes(t)) {
        const selected = new Set(item.selected_option_ids || []);
        return (
            <div style={{ display:'grid', gap:6 }}>
                <div style={label}>Odpowiedź</div>
                <ul style={{ margin:0, paddingLeft:16 }}>
                    {item.options.map(o => {
                        const isSel = selected.has(o.option_id);
                        const isGood = o.is_correct;
                        return (
                            <li key={o.option_id} style={{ color: isSel ? '#111827' : '#6b7280' }}>
                                {isSel ? '✓ ' : ''}{o.content}
                                {isGood ? <span style={{ color:'#059669', marginLeft:6 }}>(poprawna)</span> : null}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }

    // Typed (tekst/liczba)
    if (t === 'text' || t === 'textarea' || t === 'essay' || t === 'math' || t === 'numeric') {
        return (
            <div style={{ display:'grid', gap:6 }}>
                <div style={label}>Odpowiedź</div>
                {item.typed?.text ? (
                    <div style={{ whiteSpace:'pre-wrap' }}>{item.typed.text}</div>
                ) : item.typed?.numeric != null ? (
                    <code>{String(item.typed.numeric)}</code>
                ) : (
                    <div style={{ opacity:.7 }}>— brak —</div>
                )}
            </div>
        );
    }

    // Pliki (file/record/photo/whiteboard/oral)
    if (t === 'file' || t === 'record' || t === 'photo' || t === 'whiteboard' || t === 'oral') {
        const files = item.files || [];
        if (!files.length) return <div style={{ opacity:.7 }}>Brak załączników</div>;

        return (
            <div style={{ display:'grid', gap:10 }}>
                <div style={label}>Odpowiedź - załączniki</div>

                <div style={{ display:'grid', gap:12 }}>
                    {files.map(f => {
                        const mime = String(f.mimetype || '').toLowerCase();
                        const isImg = mime.startsWith('image/');
                        const isPdf = mime === 'application/pdf' || mime.startsWith('application/pdf');

                        return (
                            <div key={f.file_id} style={{ border:'1px solid #eee', borderRadius:8, padding:10 }}>
                                {/* podgląd / nazwa */}
                                {isImg && f.url ? (
                                    <img
                                        src={f.url}
                                        alt={f.filename}
                                        style={{ width:'100%', maxHeight:260, objectFit:'contain', borderRadius:6 }}
                                    />
                                ) : (
                                    <div style={{ fontWeight:600 }}>{f.filename}</div>
                                )}

                                {/* link POD załącznikiem */}
                                {f.url && (
                                    <div style={{ marginTop:8 }}>
                                        <a href={f.url} target="_blank" rel="noreferrer">
                                            {isPdf ? 'Otwórz PDF w nowej karcie' : 'Pobierz / Otwórz w nowej karcie'}
                                        </a>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    // fallback
    return <div style={{ opacity:.7 }}>—</div>;
}

export default function AttemptGrading(){
    const { id } = useParams(); // attempt_id
    const nav = useNavigate();

    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    const [ok, setOk] = useState('');
    const [bundle, setBundle] = useState(null); // { attempt, items: [...] }
    const [form, setForm] = useState({}); // qid -> { points:'', note:'' }




    async function load(){
        setLoading(true); setErr(''); setOk('');
        try{
            const r = await fetch(`/api/prowadzacy/attempt/${id}/grading`, {
                credentials:'include',
                headers: { ...authHeader() }
            });
            if (!r.ok) {
                const j = await r.json().catch(()=> ({}));
                throw new Error(j?.blad || `Błąd pobierania (${r.status})`);
            }
            const j = await r.json();
            setBundle(j);

            // zbuduj formularz z bieżących danych / auto-sugestii
            const next = {};
            for (const it of j.items || []) {
                const pts = (it.answer_points != null)
                    ? it.answer_points
                    : (it.auto_suggest_points != null ? it.auto_suggest_points : '');
                next[it.question_id] = {
                    points: pts === '' ? '' : String(pts),
                    note: it.answer_note || ''
                };
            }
            setForm(next);
        }catch(e){
            setErr(e.message || 'Błąd');
        }finally{
            setLoading(false);
        }
    }

    useEffect(()=>{ load(); /* eslint-disable react-hooks/exhaustive-deps */ }, [id]);

    const items = bundle?.items || [];
    const att = bundle?.attempt;

    const totalMax = useMemo(()=> items.reduce((s, it)=> s + Number(it.max_points || 0), 0), [items]);
    const totalCur = useMemo(()=>{
        let s = 0;
        for (const it of items) {
            const val = form[it.question_id]?.points ?? '';
            const clamped = clampToMax(val, it.max_points);
            s += Number(clamped || 0);
        }
        return Math.round(s * 100) / 100;
    }, [items, form]);

    function changePoints(qid, max, v) {
        setForm(prev => ({
            ...prev,
            [qid]: {
                points: v,
                note: prev[qid]?.note ?? ''
            }
        }));
    }
    function changeNote(qid, v) {
        setForm(prev => ({
            ...prev,
            [qid]: {
                points: prev[qid]?.points ?? '',
                note: v
            }
        }));
    }

    async function doSave(complete=false){
        setErr(''); setOk('');
        try{
            const payload = {
                items: items.map(it => {
                    const raw = form[it.question_id]?.points ?? '';
                    const val = clampToMax(raw, it.max_points);
                    return {
                        question_id: it.question_id,
                        points: (val === '' ? null : val),
                        note: form[it.question_id]?.note ?? null
                    };
                })
            };

            const url = complete
                ? `/api/prowadzacy/attempt/${id}/grading/complete`
                : `/api/prowadzacy/attempt/${id}/grading/save`;

            const r = await fetch(url, {
                method:'POST',
                credentials:'include',
                headers:{ 'Content-Type':'application/json', ...authHeader() },
                body: JSON.stringify(payload)
            });
            if (!r.ok) {
                const j = await r.json().catch(()=> ({}));
                throw new Error(j?.blad || `Błąd zapisu (${r.status})`);
            }
            await load();
            setOk(complete ? 'Zapisano i zakończono ocenianie.' : 'Zapisano.');
            if (complete) {
                 nav(`/prowadzacy/attempt/${id}`);
            }
        }catch(e){
            setErr(e.message || 'Błąd zapisu');
        }
    }

    return (
        <div style={{ padding:16, marginTop:50 }}>
            <h1 style={{ marginBottom:12 }}>Ocenianie</h1>

            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{ color:'crimson' }}>{err}</div>
            ) : !bundle ? (
                <div>Brak danych.</div>
            ) : (
                <div style={{ display:'grid', gap:16 }}>
                    {/* Nagłówek z podsumowaniem */}
                    <div style={card}>
                        <div style={{ display:'flex', gap:16, alignItems:'baseline', flexWrap:'wrap' }}>
                            <div style={{ fontWeight:700, fontSize:18 }}>
                                {att?.first_name} {att?.last_name} <span style={{ color:'#6b7280' }}>({att?.indeks})</span>
                            </div>
                            <div style={{ marginLeft:'auto', fontSize:16 }}>
                                <b>Suma:</b> {totalCur} / {totalMax}
                            </div>
                        </div>
                    </div>

                    {/* Lista pytań */}
                    <div style={{ display:'grid', gap:12 }}>
                        {items.map((it, idx) => {
                            const fp = form[it.question_id]?.points ?? '';
                            const clamped = clampToMax(fp, it.max_points);
                            const note = form[it.question_id]?.note ?? '';

                            return (
                                <div key={it.question_id} style={card}>
                                    <div style={{ fontSize:13, color:'#6b7280', marginBottom:6 }}>Pytanie {idx+1}</div>

                                    <div style={row}>
                                        {/* LEWA: treść i odpowiedź */}
                                        <div style={{ display:'grid', gap:10 }}>
                                            <div>
                                                <div style={label}>Treść pytania</div>
                                                <div>{it.content}</div>
                                            </div>
                                            {(it.question_files && it.question_files.length > 0) && (
                                                <div style={{ marginTop:8 }}>
                                                    <div style={label}>Załączniki pytania</div>
                                                    <div style={{ display:'grid', gap:12 }}>
                                                        {it.question_files.map(f => <FileTile key={f.file_id} f={f} />)}
                                                    </div>
                                                </div>
                                            )}
                                            <AnswerView item={it} />
                                        </div>

                                        {/* PRAWA: ocena */}
                                        <div style={{ display:'grid', gap:8 }}>
                                            <label style={{ display:'grid', gap:6 }}>
                                                <span style={label}>Punkty (max {it.max_points})</span>
                                                <input
                                                    type="number"
                                                    step="0.1"
                                                    value={fp}
                                                    onChange={e => changePoints(it.question_id, it.max_points, e.target.value)}
                                                    onBlur={() => changePoints(it.question_id, it.max_points, String(clamped))}
                                                    style={{ width:'100%', padding:'8px', border:'1px solid #e5e7eb', borderRadius:8 }}
                                                />
                                            </label>

                                            <label style={{ display:'grid', gap:6 }}>
                                                <span style={label}>Notatka</span>
                                                <textarea
                                                    rows={3}
                                                    value={note}
                                                    onChange={e => changeNote(it.question_id, e.target.value)}
                                                    style={{ width:'100%', padding:'8px', border:'1px solid #e5e7eb', borderRadius:8 }}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Akcje */}
                    <div style={{ display:'flex', gap:8 }}>
                        <button
                            onClick={()=>doSave(false)}
                            style={{ border:'1px solid #e5e7eb', borderRadius:8, padding:'8px 12px', background:'#f9fafb' }}
                        >
                            Zapisz
                        </button>
                        <button
                            className={'but-smal'}
                            onClick={()=>doSave(true)}
                        >
                            Zapisz i zakończ ocenianie
                        </button>
                        <button
                            onClick={()=>nav(`/prowadzacy/attempt/${id}`)}
                            style={{ marginLeft:'auto', border:'1px solid #e5e7eb', borderRadius:8, padding:'8px 12px', background:'#fff' }}
                        >
                            Szczegóły podejścia
                        </button>
                    </div>

                    {ok && <div style={{ color:'#059669' }}>{ok}</div>}
                    {err && <div style={{ color:'#dc2626' }}>{err}</div>}
                </div>
            )}
        </div>
    );
}
